import React from 'react'
import { Chart, registerables } from "chart.js"
import { Doughnut } from "react-chartjs-2"

// Chart.jsの登録
Chart.register(...registerables)

type Props = {
    data: number[] // データの型定義
}

const DoughnutChart = (props: Props) => {
    // グラフのデータ設定
    const data = {
        labels: ["正解", "不正解"],
        datasets: [{
            data: props.data,
            backgroundColor: [
                "#5de395", // 正解の色
                "#f59787", // 不正解の色
            ],
            }
        ],
    }

  return (
    <div>
      <div style={{ width: "300px", margin: "0 auto"}}>
        <Doughnut data={data} /> {/* ドーナツチャートの描画 */}
      </div>
    </div>
  );
}

export default DoughnutChart